export default __webpack_public_path__ + "static/media/pantry1-afterF.655d2e36.jpg";